import { html } from '@microsoft/fast-element';
export const foundationGridLayoutItemTemplate = html `
  <template>
    <style>
      :host {
        width: 100%;
        height: 100%;
        ${(x) => x.setGridItemProperties(x.colNumber, x.rowNumber, x.width, x.height)}
      }

      @media only screen and (min-width: 1025px) {
        :host {
          ${(x) => x.setGridItemProperties(x.colLgNumber, x.rowLgNumber, x.widthLg, x.heightLg)}
        }
      }

      @media only screen and (min-width: 641px) and (max-width: 1024px) {
        :host {
          ${(x) => x.setGridItemProperties(x.colMdNumber, x.rowMdNumber, x.widthSm, x.heightMd)}
        }
      }

      @media only screen and (max-width: 640px) {
        :host {
          ${(x) => x.setGridItemProperties(x.colSmNumber, x.rowSmNumber, x.widthSm, x.heightSm)}
        }
      }
    </style>
    <slot></slot>
  </template>
`;
